import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LoadingController, ModalController } from '@ionic/angular';
import { settings } from 'src/app/settings';
import { AuthService } from 'src/app/shared/services/auth.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { BasePage } from '../../base.page';

@Component({
  selector: 'app-login-as',
  templateUrl: './login-as.component.html',
  styleUrls: ['./login-as.component.scss'],
})
export class LoginAsComponent extends BasePage {
  loginAsForm: UntypedFormGroup;

  isPermalinkFormSubmitted = false;

  logo = `assets/img/${settings.brand.folder}/logo.png`;

  constructor(
    private auth: AuthService,
    public modalCtrl: ModalController,
    protected fb: UntypedFormBuilder,
    public loadingCtrl: LoadingController,
    private utilityService: UtilityService,
  ) {
    super('LoginAsComponent');

    this.loginAsForm = fb.group({
      permalink: ['', Validators.required],
    });
  }

  /**
   * Login as using permalink
   * Shown only if you are logged in as an admin
   */
  async loginAs() {
    if (this.loginAsForm.valid) {
      await this.showLoading('Logging in...');
      try {
        await this.auth.loginAs(this.loginAsForm.value.permalink);
        this.closeModal(true);
      } catch (e) {
        this.utilityService.showAlert('Login Error', 'Invalid permalink');
      } finally {
        this.hideLoading();
      }
    }
  }
}
